module.exports = __webpack_public_path__ + "img/effect_4.f175b07b.jpg";